import { React, Fragment, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Badge,
  FormGroup,
  Input,
  Label,
  CardFooter,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useCallback } from "react";
import { fetchSkillsRequest } from "../../../redux/mandatorySkills/actions";
import { customOptionsStyle } from "../../../Constant";
import {
  addSkillsRequest,
  resetData,
} from "../../../redux/jobseeker/skills/actions";
import { showToast } from "../../Common/Toast";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
const AddskillModal = ({ profileData, validationMessages }) => {
  console.log("skd", profileData);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    id: profileData ? profileData.id : null,
    skills: profileData ? profileData.skill : null,
  });

  const handleSkillsChange = (selectedOptions) => {
    setFormData({ ...formData, skills: selectedOptions });
  };

  const handleSkillInputChange = useCallback(
    (inputValue) => {
      // Fetch data based on the inputValue (keyword)
      const fetchData = async () => {
        try {
          dispatch(fetchSkillsRequest(inputValue));
        } catch (error) {
          // Handle any errors if necessary
        }
      };

      // Call the fetchData function when the location input changes
      fetchData();
    },
    [dispatch]
  );

  const handleSkillFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchSkillsRequest(keyword));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  let skillReducerData = useSelector((state) => state.mandatorySkillsReducer);
  console.log("srd", skillReducerData);
  let skillData = skillReducerData.data.data;
  // let skillData = [];

  const handleSubmit = (e) => {
    // e.preventDefault();
    // const data = {
    //   skill_id: formData.skills.map((skill) => skill.value).join(","),
    // };
    // dispatch(addSkillsRequest(data));

    e.preventDefault();

    // Check if any skills are selected
    if (!formData.skills || formData.skills.length === 0) {
      setErrors({ skills: "Please select at least one skill." });
      return; // Exit early if no skills are selected
    }

    // Reset errors if there are any
    setErrors({});

    // Prepare data for submission
    const data = {
      skill_id: formData.skills.map((skill) => skill.value).join(","),
    };

    // Dispatch action to add skills
    dispatch(addSkillsRequest(data));
  };

  const addSkillReducerData = useSelector((state) => state.skillsReducer);
  useEffect(() => {
    console.log("srd", addSkillReducerData);
    if (addSkillReducerData.status && addSkillReducerData.message != "") {
      showToast("success", addSkillReducerData.message);

      dispatch(fetchJobseekerDataRequest());
      setFormData({
        id: profileData ? profileData.id : null,
        skills: null,
      });
      setErrors({});
      // props.toggleModal();
      dispatch(resetData());
    } else if (
      addSkillReducerData.status == false &&
      addSkillReducerData.message != ""
    ) {
      showToast("error", addSkillReducerData.message);

      // props.toggleModal();
      dispatch(resetData());
    }
  }, [addSkillReducerData]);

  useEffect(() => {
    // Check if there are validation messages on page load
    if (validationMessages && validationMessages.length > 0) {
      const newErrors = {};
      validationMessages.forEach((msg) => {
        newErrors[msg.field] = msg.message;
      });
      setErrors(newErrors);
    }
  }, [validationMessages]);

  return (
    <Form onSubmit={handleSubmit}>
      <CardHeader className="border-0">
        <h4>Add Skills</h4>
      </CardHeader>
      <CardBody className="pt-0">
        <FormGroup>
          <Label>
            <b>Skill</b>
            <span className="text-danger">*</span>
          </Label>
          <Row>
            <Col md="10">
              <Select
                placeholder="Select skills"
                isLoading={skillReducerData.isLoading}
                options={skillData}
                value={formData.skills}
                onChange={handleSkillsChange}
                styles={customOptionsStyle}
                onFocus={handleSkillFocus}
                onInputChange={handleSkillInputChange}
                isMulti={true}
              />
              {errors.skills && (
                <small className="text-danger">{errors.skills}</small>
              )}
            </Col>
            <Col>
              {" "}
              <Button
                disabled={addSkillReducerData.isLoading}
                color="primary"
                type="submit"
              >
                Add
              </Button>
            </Col>
          </Row>
        </FormGroup>
      </CardBody>
    </Form>
  );
};

export default AddskillModal;
